import { faPenToSquare } from "@fortawesome/pro-light-svg-icons"
import { Button } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { useSendMailModalStore } from "./hooks/useSendMailModalStore"
import useMobile from "../../../../hooks/useMobile"

const SendMailButton = ({ userId }: { userId?: number }) => {
  const { onOpen } = useSendMailModalStore()
  const isMobile = useMobile()
  const { t } = useTranslation()

  return (
    <Button
      text={isMobile ? "" : t("MAIL_SEND")}
      buttonType="primary"
      icon={faPenToSquare}
      onClick={() => onOpen(userId)}
      style={{
        height: isMobile ? "56px" : "44px",
        maxHeight: isMobile ? "56px" : "44px",
        minHeight: isMobile ? "56px" : "44px",
        width: isMobile ? "56px" : "unset",
        maxWidth: isMobile ? "56px" : "unset",
      }}
    />
  )
}

export default SendMailButton
